exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-button[data-v-97c902c2] {\n  min-height: 60px;\n}\n.image-card[data-v-97c902c2] {\n  position: relative;\n}\n.image-card.offline[data-v-97c902c2] {\n  opacity: 0.4;\n}\n.image-card .delete-button[data-v-97c902c2] {\n  right: -10px;\n  top: -10px;\n}\n.image-card .cloud-icon[data-v-97c902c2] {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\ninput[type=file][data-v-97c902c2] {\n  position: absolute;\n  left: -99999px;\n}", ""]);

// exports
